import React, { useState } from "react";
import WriteBox from "../../QuestionPage/WordBox";
import QuestionBox from "../../QuestionPage/questionbox";
import Timer from "../Timer";
import ExamPanel from "../ExamPanel";

export default function SummarizeMockPage({
  question,
  onInputChange,
  questionNumber,
  totalQuestions = 36,
}) {
  const [text, setText] = useState("");

  const handleTextChange = (newText) => {
    setText(newText);
    onInputChange(newText);
  };

  return (
    <ExamPanel
      eyebrow="Writing"
      title="Summarize Written Text"
      questionLabel={`Question ${questionNumber} of ${totalQuestions}`}
      meta={
        <span className="inline-flex items-center gap-1">
          Time left: <Timer initialMinutes={10} initialSeconds={0} />
        </span>
      }
      instructions="Read the passage and summarize it using one sentence. Your response will be judged on writing quality and how well it presents the key points."
    >
      <div className="space-y-5">
        <QuestionBox
          question={question?.question || ""}
          eyebrow="Passage"
          title="Summarize this passage in one sentence"
        />

        <WriteBox
          onTextChange={handleTextChange}
          minHeight="min-h-[12rem]"
          title="Type one sentence"
          helper="Aim for one clear sentence that captures the key point."
          placeholder="Write your one-sentence summary..."
        />
      </div>
    </ExamPanel>
  );
}
